module.exports = __webpack_public_path__ + "VIPV35.png?fee1dc0933fe0144fe0c63c6e8c9a01f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV35.png
// module id = 131
// module chunks = 0